import { useState } from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CancelSubscription from "./CancelSubscriptionModal";
import "./index.scss";
import { useNavigate } from "react-router-dom";
const ProfileSetting = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const handleCancelSubscriptionClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <article className="full-vh settings-page pb-5">
      <Grid className="setting">
        <h2>{t("settings.heading")}</h2>
      </Grid>
      <section className="profile-setting">
        <div className="col-section">
          <div className="eins-section">
            <Grid container spacing={2} justifyContent="center">
              <Grid
                onClick={() => {
                  navigate("/profile");
                }}
                item
                lg={4}
                md={6}
                sm={12}
              >
                <div className="einslist cursor-pointer">
                  <Card variant="outlined">
                    <CardContent className="Card-color">
                      <Typography
                        gutterBottom
                        variant="h6"
                        component="div"
                        className="card-text"
                      >
                        {t("settings.profile")}
                      </Typography>
                    </CardContent>
                  </Card>
                </div>
              </Grid>
              {localStorage.getItem("role") == "#EU" && (
                <Grid item lg={4} md={6} sm={12}>
                  <div
                    className="cursor-pointer"
                    onClick={handleCancelSubscriptionClick}
                  >
                    <Card variant="outlined">
                      <CardContent className="Card-color">
                        <Typography
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="card-text"
                        >
                          {t("settings.offBoard")}
                        </Typography>
                      </CardContent>
                    </Card>
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
        </div>
      </section>
      <CancelSubscription open={open} handleClose={handleClose} />
    </article>
  );
};

export default ProfileSetting;
